import { FinTechPageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function FinTech() {
  return (
    <FinTechPageProvider>
      <IndustryPageLayout />
    </FinTechPageProvider>
  );
}
